import { useState } from "react";
import { Gauge, EnvelopeSimple, ListNumbers, VideoCamera, AirplaneTilt, Translate } from "@phosphor-icons/react";
import { MbLexique } from "../components/muayboran/MbLexique";
import { MbDashboard } from "../components/muayboran/MbDashboard";
import { MbCommunications } from "../components/muayboran/MbCommunications";
import { MbKhans } from "../components/muayboran/MbKhans";
import { MbVideos } from "../components/muayboran/MbVideos";
import { MbBlitz } from "../components/muayboran/MbBlitz";

const TABS = [
  { id: "bord", label: "Tableau de bord", icon: Gauge },
  { id: "com", label: "Communications & Outreach AI", icon: EnvelopeSimple },
  { id: "khans", label: "Curriculum & Khan Roadmap", icon: ListNumbers },
  { id: "videos", label: "Vidéothèque & revue privée", icon: VideoCamera },
  { id: "blitz", label: "Blitz Thaïlande", icon: AirplaneTilt },
  { id: "lexique", label: "Lexique thaï (quiz)", icon: Translate },
];

/** Module privé du fondateur — Kaizen Muay Boran : Road to Kru & Ajahn. */
export default function MuayBoranModule() {
  const [tab, setTab] = useState("bord");
  return (
    <div className="p-4 md:p-8 space-y-6 max-w-7xl" data-testid="muayboran-module">
      <header className="relative overflow-hidden rounded-2xl border border-amber-500/20 bg-[#141210] p-6 md:p-8">
        <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-red-700/20 blur-3xl" aria-hidden />
        <div className="absolute right-24 bottom-0 h-32 w-32 rounded-full bg-amber-500/15 blur-2xl" aria-hidden />
        <div className="text-[11px] tracking-[0.35em] uppercase text-amber-400/80 font-bold">Kaizen Muay Boran · privé</div>
        <h1 className="mt-2 text-3xl md:text-5xl font-black text-zinc-50 font-display leading-tight">Road to <span className="text-amber-400">Kru</span> & <span className="text-red-400">Ajahn</span></h1>
        <p className="mt-2 text-sm md:text-base text-zinc-400 max-w-3xl">Pratique autonome à Val-d'Or toute l'année, correspondance avec les académies thaïlandaises, validation vidéo à distance et blitz d'immersion de 21 à 28 jours. Système des Khans KMA / WMBF — 14 paliers.</p>
      </header>
      <nav className="flex gap-2 overflow-x-auto pb-1" data-testid="muayboran-tabs">
        {TABS.map((t) => (
          <button key={t.id} type="button" onClick={() => setTab(t.id)} data-testid={`mb-tab-${t.id}`}
            className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${tab === t.id ? "bg-amber-500 text-zinc-950" : "bg-zinc-900 border border-zinc-800 text-zinc-300 hover:border-amber-500/50"}`}>
            <t.icon weight={tab === t.id ? "fill" : "regular"} /> {t.label}
          </button>
        ))}
      </nav>
      {tab === "bord" && <MbDashboard onGo={setTab} />}
      {tab === "com" && <MbCommunications />}
      {tab === "khans" && <MbKhans />}
      {tab === "videos" && <MbVideos />}
      {tab === "blitz" && <MbBlitz />}
      {tab === "lexique" && <MbLexique />}
    </div>
  );
}
